import { getMobileAndDesktopFirstImage } from 'components/PageSections/utils';

import { NavigationAnchorProps, TileProps } from './NavigationAnchor';

export const parseNavigationAnchor = (
  section: Queries.ContentfulSection001,
): NavigationAnchorProps | null => {
  if (!section) {
    return null;
  }
  const subsections =
    (section?.subsections as Queries.ContentfulSection001[]) || [];

  const tiles = subsections.map((subsection) => {
    const { images, metadata } = subsection;
    const title = metadata?.title || '';
    const { desktopImage, mobileImage } = getMobileAndDesktopFirstImage(images);
    const mobileOnly = metadata?.context?.mobileOnly || false;
    const cta =
      metadata?.ctas?.[0] || ({} as Queries.ContentfulCallToAction001);

    return {
      id: subsection?.metadata?.metadata_id || '',
      anchor: cta.url || '',
      buttonLabel: cta.label || '',
      desktopImage,
      iconName: cta.metadata?.context?.ctaParts?.icon || '',
      mobileImage,
      mobileOnly,
      title,
    } as TileProps;
  });

  return {
    tiles,
    id: section?.metadata?.metadata_id!,
  };
};

type ReturnType = {
  mainAnchorSectionId: string | undefined;
  anchorsSectionsIds: string[];
};

export const getAnchorsSectionsIds = (
  sections: Queries.ContentfulSection001[] | undefined,
): ReturnType => {
  //@ts-ignore
  const section = sections?.find(
    (section: Queries.ContentfulSection001 | undefined) =>
      section?.componentName === 'NavigationAnchor' || '',
  );

  const anchorSection = section
    ? parseNavigationAnchor(section as Queries.ContentfulSection001)
    : null;

  if (!anchorSection) {
    return {
      mainAnchorSectionId: undefined,
      anchorsSectionsIds: [],
    };
  }

  const { id: mainAnchorSectionId, tiles } = anchorSection;

  return {
    mainAnchorSectionId,
    anchorsSectionsIds: tiles.reduce((acc, tile) => {
      if (tile.anchor?.startsWith('#')) {
        return [...acc, tile.anchor || ''];
      }
      return acc;
    }, [] as string[]),
  };
};
